import { SVGProps, Ref, forwardRef } from 'react'
const SvgTimelineClock = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M11.25 17.25a6 6 0 1 0 12 0 6 6 0 0 0-12 0Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M19.902 17.25H17.25v-2.652M1 4h16M1 14h8M1 9h13M1 19h4"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgTimelineClock)
export default ForwardRef
